import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Link,
    List,
    Tooltip,
  } from "@mui/material";
  import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { downloadTalkingPointFileRequest } from "../../../../actions";
import { IRootReducer } from "../../../../reducers";
import { IncidentTalkingPoint } from "../../../../reducers/states/vcc-incident";
  
  interface TalkingPointAttachmentsProps {
    props: {
      incidentId: string;
      talkingPointId: string;
    };
  }
  
  const TalkingPointAttachmentsModal: FC<TalkingPointAttachmentsProps> = ({ props }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [talkingpoint, setTalkingPoint] = useState({} as IncidentTalkingPoint);

    const talkingPointStore = useSelector(
      (state: IRootReducer) => state.vccIncidentReducer.talkingPoints
    );
  
    const handleOpen = () => {
      setOpen(true);
      let foundTalkingPoint = talkingPointStore.find((o) => o.id === props.talkingPointId);
      if(foundTalkingPoint){
        setTalkingPoint(foundTalkingPoint);
      }
    };

    const handleDownloadFile = (fileId: string) => {
      dispatch(downloadTalkingPointFileRequest(props.incidentId, props.talkingPointId, fileId));
    };
  
    const handleCancel = () => {
      setOpen(false);
    };
  
    return (
      <>
        <Tooltip title="View attachments of this talking point">
          <Box>
            <Button
              color="primary"
              onClick={handleOpen}
            >
              View
            </Button>
          </Box>
        </Tooltip>
        <Dialog
          open={open}
          onClose={handleCancel}
          aria-labelledby="form-dialog-title"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">Attachments for Talking Point:</DialogTitle>
          <DialogContent>
            <Grid container>
                <Grid container item xs={6}>
                    <Grid item xs={12}>
                        Links:
                    </Grid>
                    <Grid item xs={12}>
                      <List style={{ maxHeight: "25vh", overflow: "scroll" }}>
                        {talkingpoint.links?.length ? (
                          talkingpoint.links.map((l, index) => (
                            <Box key={l + index}>
                              <Link href={l} target="_blank">{l}</Link>
                            </Box>
                          ))
                        ) : (
                          <Grid>
                            <Box fontStyle="italic" fontSize="12px">
                              No links
                            </Box>
                          </Grid>
                        )}
                      </List>
                    </Grid>
                </Grid>
                <Grid container item xs={6}>
                    <Grid item xs={12}>
                        Files:
                    </Grid>
                    <Grid item xs={12}>
                      <List style={{ maxHeight: "25vh", overflow: "scroll" }}>
                        {talkingpoint.fileIds?.length ? (
                          talkingpoint.fileIds.map((f, index) => (
                            <Box key={f + index}>
                              {f} 
                              <Button onClick={() => handleDownloadFile(f)} data-rum-id={`talking-point-attachment__${f}`}>
                                Download
                              </Button>
                            </Box>
                          ))
                        ) : (
                          <Grid>
                            <Box fontStyle="italic" fontSize="12px">
                              No files
                            </Box>
                          </Grid>
                        )}
                      </List>
                    </Grid>
                </Grid>
            </Grid>
            <DialogActions>
              <Button onClick={() => setOpen(false)} variant="contained" color="primary">
                Close
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </>
    );
  };
  
  export default TalkingPointAttachmentsModal;
  